import React, { useState } from 'react';
import { Link } from 'gatsby';

import BlackArrow from '~/icons/black-arrow.svg';
import WhiteArrow from '~/icons/white-arrow.svg';
import SparksBlue from '~/icons/sparks-blue.svg';
import SparksBlack from '~/icons/sparks-black.svg';
import SparksWhite from '~/icons/sparks.svg';
import { AnimatePresence, motion } from 'framer-motion';
import renderLink from '~/utils/render-link';

function ShadowButton({ title, button, className = '', dark = false,  ...other }) {
  const [showIcon, setShowIcon] = useState(false);



  return (
    <div className={`${className}`} {...other}>
      <Link
        to={renderLink(button?.cached_url || button?.url || '#')}
        className={`flex items-center justify-between bg-black c-btn c-btn--white c-btn--outline c-btn--outline--black-shadow py-5 md:py-9 lg:px-5 xl:px-8 ${dark && 'c-btn--outline--black-shadow--outline'} `}
        onMouseEnter={() => setShowIcon(true)}
        onMouseLeave={() => setShowIcon(false)}
      >
        {showIcon ? (
          <AnimatePresence exitBeforeEnter>
            <motion.img
              key={`hoverImg1`}
              initial={{ opacity: 0, y: 50, scale: 0.2 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 1.4 }}
              src={SparksBlue}
              alt=""
              className={`w-10 h-10 mr-4`}
            />
          </AnimatePresence>
        ) : (
          <AnimatePresence exitBeforeEnter>
            <motion.img
              key={`hoverImg2`}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              src={dark ? SparksWhite : SparksBlack}
              alt=""
              className={`w-10 h-10 mr-4`}
            />
          </AnimatePresence>
        )}

        <div className="flex-auto text-18px">{title}</div>
        {dark ? (
          <img className={`ml-6`} src={showIcon ? BlackArrow : WhiteArrow} alt="" />
        ) : (
          <img className={`ml-6`} src={BlackArrow} alt="" />
        ) }
      </Link>
    </div>
  );
}

export default ShadowButton;
